var ee_sideCart = {
  init: function() {
    this.registerHandlebarsHelpers();
    this.afterAjaxCart();
  },

  getCart: function(callback) {
    $.getJSON("/cart.js", callback);
  },

  get_ga_linker: function() {
    // Build the ga_linker param for the URL generator
    try {
      return [ga.getAll()[0].get('linkerParam')];
    } catch (e) {
      return [];
    }
  },

  registerHandlebarsHelpers: function() {
    Handlebars.registerHelper("ifEquals", function(arg1, arg2) {
      return arg1 == arg2 ? this : !this;
    });

    Handlebars.registerHelper("greaterThanEquals", function(arg1, arg2) {
      return arg1 >= arg2 ? this : !this;
    });

    Handlebars.registerHelper("or", function(arg1, arg2, arg3) {
      return arg1 || arg2 || arg3 ? this : !this;
    });
  },

  afterAjaxCart: function() {
    var self = this;
    $("body").on("ajaxCart.afterCartLoad", function() {
      self.getCart(function(cart) {
        var cartToken = cart.token;
        var cartItems = cart.items;
        var hasSubscription = false;
        cartItems.forEach(function(item){
          if(item.properties && (item.properties.shipping_interval_frequency || item.properties.shipping_interval_unit_type)){
            hasSubscription = true;
            return false;
          }
        });

        if(hasSubscription){
          $(".additional_checkout_buttons").hide();
          $(".cart__checkout").hide();
          $(".ajaxcart__footer").append(`<a href='${self.buildCheckoutURL(cartToken)}' class='button'>Check Out →</a>`)
        }
      });
    });
  },

  buildCheckoutURL: function(token){
    var checkout_url = 'https://checkout.rechargeapps.com/r/checkout?',
    permanent_domain = window.Shopify.shop,
				url_params = [
					'myshopify_domain=' + permanent_domain
				];
			url_params = url_params
				.concat(['cart_token=' + token]).concat(this.get_ga_linker());
			return checkout_url + url_params.join('&');
  }


};

$(ee_sideCart.init());